module.exports = __webpack_public_path__ + "img/tooltip-vallone-como-gunmetal-02.96367a3b.jpg";